/*
 * 模块: 文件处理工具
 * 职责: 提供文件验证、格式化等功能
 * 依赖: 无
 * 导出: 文件处理函数
 * 限制: 文件<280行, 函数<30行, 纯函数无副作用
 */

/**
 * 验证文件类型是否为支持的Excel/CSV格式
 * 
 * @param file 文件对象
 * @returns 是否为有效文件
 */
export const isValidFileType = (file: File): boolean => {
  const fileName = file.name.toLowerCase();
  return fileName.endsWith('.xlsx') || fileName.endsWith('.xls') || fileName.endsWith('.csv');
};

/**
 * 批量验证文件类型
 * 
 * @param files 文件数组
 * @returns { validFiles, invalidFiles }
 */
export const validateFiles = (files: File[]) => {
  const validFiles: File[] = [];
  const invalidFiles: File[] = [];
  
  files.forEach(file => {
    if (isValidFileType(file)) {
      validFiles.push(file);
    } else {
      invalidFiles.push(file);
    }
  });
  
  return { validFiles, invalidFiles };
};

/**
 * 格式化文件大小
 * 
 * @param bytes 字节数
 * @returns 格式化后的字符串 (如: "1.23 MB")
 */
export const formatFileSize = (bytes?: number): string => {
  if (!bytes) return '未知大小';
  
  const kb = bytes / 1024;
  const mb = kb / 1024;
  
  if (mb >= 1) {
    return `${mb.toFixed(2)} MB`;
  }
  
  return `${kb.toFixed(2)} KB`;
};

/**
 * 从错误响应中提取友好的错误消息
 * 
 * @param error 错误对象
 * @returns 用户友好的错误消息
 */
export const extractErrorMessage = (error: any): string => {
  if (error.code === 'ECONNABORTED') {
    return '上传超时（文件过大或网络缓慢）';
  }
  
  if (error.response?.status === 413) {
    return '文件过大，请检查总大小';
  }
  
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  
  if (error.message) {
    return error.message;
  }
  
  return '未知错误';
};

